import React from "react";
import classnames from "classnames";
import Overlay from "Shared/Overlay";
import connect from "Shared/connect";
import { formatPrice } from "Shared/number-format";
import { toggleMiniCart } from "../../../../../MiniCart/action-creators";
import { reloadCart } from "../../../../../../Cart/action-creators";
import { SMALL } from "Shared/breakpoints";
import * as miniCartStyles from "./mini-cart-button.scss";
import MyMenigoIcon from "../../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import { hideDeliveryDays } from "../../../../action-creators";
import ToolTip from "Shared/ProductTooltip/ToolTip";
import { translate } from 'Shared/translate';
function getCount(cart) {
    if (!!cart.items && cart.items.length > 0) {
        const codes = cart.items.map((x, i) => {
            return x.lineItem.code;
        });
        if (codes.length > 0) {
            const distinctCodes = codes.reduce((distinct, code) => distinct.indexOf(code) !== -1 ? distinct : [...distinct, code], []);
            if (distinctCodes.length === 1) {
                return distinctCodes.length;
            }
            return distinctCodes.length;
        }
    }
    return 0;
}
class MiniCartButton extends React.Component {
    constructor() {
        super(...arguments);
        this.toggleOverlay = (e) => {
            if (e) {
                e.stopPropagation();
            }
            this.props.hideDeliveryDays();
            this.props.reloadCart();
            if (this.props.currentBreakpoint > SMALL) {
                !this.props.miniCartIsOpen && this.attachOutsideClickOnOverlay();
                !!this.props.miniCartIsOpen && this.detatchOutsideClickOnOverlay();
            }
            !!!this.props.deliveryDaysIsVisible && this.props.toggleMiniCart();
        };
        this.attachOutsideClickOnOverlay = () => {
            document.addEventListener("click", this.clickOutside);
        };
        this.detatchOutsideClickOnOverlay = () => {
            document.removeEventListener("click", this.clickOutside);
        };
        this.clickOutside = (evt) => {
            if (!this.miniCartElement) {
                return;
            }
            if (!this.button.contains(evt.target) ||
                !this.miniCartElement.contains(evt.target)) {
                this.toggleOverlay();
            }
        };
    }
    render() {
        const isTooltip = this.props.currentBreakpoint > SMALL;
        const count = getCount(this.props.cart);
        const formattedPrice = formatPrice(!!this.props.cart.subTotal ? this.props.cart.subTotal.current : 0) +
            " " +
            (!!this.props.cart.subTotal
                ? this.props.cart.subTotal.currencySymbol
                : "");
        if (this.props.isRestrictedCustomer) {
            return null;
        }
        const button = (React.createElement("button", { type: "button", "data-total": !this.props.isSupplierSalesman ? formattedPrice : '', "data-count": !!count ? count : 0, onClick: this.toggleOverlay, className: classnames(miniCartStyles.button, this.props.miniCartIsOpen && miniCartStyles.open, this.props.cart.items.length > 0 ? miniCartStyles.Cart__NotEmpty : miniCartStyles.Cart__Empty), ref: el => (this.button = el) },
            React.createElement("div", { className: classnames(!!!this.props.miniCartIsOpen && miniCartStyles.inner) },
                React.createElement("div", { className: miniCartStyles.CartIcon },
                    count > 0 && React.createElement("span", { className: miniCartStyles.orderRows }, count),
                    React.createElement(MyMenigoIcon, { name: "shoppingbag" })))));
        return (React.createElement("div", { ref: (el) => (this.miniCartElement = el) },
            React.createElement(Overlay, { enabled: isTooltip && this.props.miniCartIsOpen, className: classnames(miniCartStyles.base, "ui-test-mini-cart") }, !this.props.isSupplierSalesman && !this.props.miniCartIsOpen ? (React.createElement(ToolTip, { className: miniCartStyles.tooltip, text: translate('/MiniCart/ToPay') + ' : ' + formattedPrice, direction: "custom", disableAdjust: true }, button)) :
                button)));
    }
}
export default connect((state) => ({
    miniCartIsOpen: state.miniCart.isOpen,
    currentBreakpoint: state.currentBreakpoint,
    cart: state.cart,
    isSupplierSalesman: state.currentUser.isSupplierSalesman,
    isRestrictedCustomer: state.appShellData.currentUser.isRestrictedCustomer,
    deliveryDaysIsVisible: state.deliveryDaysVisibility.visible,
}), (dispatch) => ({
    toggleMiniCart: (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        dispatch(toggleMiniCart());
    },
    reloadCart() {
        return dispatch(reloadCart());
    },
    hideDeliveryDays() {
        return dispatch(hideDeliveryDays());
    },
}))(MiniCartButton);
